import * as API from './index'

export default {    
    sendSms: params => {
        return API.POST('/api/Sms/SendSms', params)
    }   
}


// WEBPACK FOOTER //
// ./src/apis/sms.js